import { Menu } from 'lucide-react'
import { env } from '@/config/env'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { RealtimeIndicator } from './RealtimeIndicator'
import { ThemeToggle } from './ThemeToggle'
import { UserMenu } from './UserMenu'

export function Header({
  title,
  onOpenMobileMenu,
}: {
  title: string
  onOpenMobileMenu: () => void
}) {
  // Faz parte da moldura com o menu lateral (mesma superfície, sem linha divisória).
  return (
    <header className="z-30 shrink-0 bg-card">
      <div className="flex h-[4.5rem] items-center gap-2 px-4 lg:pl-5 lg:pr-6">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden"
          onClick={onOpenMobileMenu}
          aria-label="Abrir menu"
        >
          <Menu className="h-4 w-4" />
        </Button>

        <p className="min-w-0 flex-1 truncate text-base font-semibold tracking-tight">{title}</p>

        {env.useMockApi ? (
          <Badge tone="warning" className="hidden sm:inline-flex" title="Dados simulados com MSW">
            Modo mock
          </Badge>
        ) : null}
        <RealtimeIndicator />
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  )
}
